import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  routes,
  history: createWebHistory('/'),
  linkActiveClass: 'is-active',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (savedPosition) {
          // If there's a saved position (back/forward button), restore it
          resolve(savedPosition);
        } else {
          // For new navigations, scroll to top
          resolve({
            left: 0,
            top: 0
          });
        }
      }, 300);
    });
  },
});

router.isReady().then(() => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 300);
});


export default router;
